export default __webpack_public_path__ + "static/media/blog_pic_2.3a6baa77.jpg";